import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';

import { ListItem } from 'material-ui/List';

import Avatar from 'material-ui/Avatar';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import LaunchIcon from 'material-ui/svg-icons/action/launch';

import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import InfoIcon from 'material-ui/svg-icons/action/assignment';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import PrivateIcon from 'material-ui/svg-icons/action/lock';
import SkillIcon from 'material-ui/svg-icons/social/public';
import DoneIcon from 'material-ui/svg-icons/action/done';
import SpotIcon from 'material-ui/svg-icons/image/lens';

import LinearProgress from 'material-ui/LinearProgress';
import CourseProgressBar from '../ProgressBar/CourseProgressBar';

import { avatar as avatarColours, statusColours } from '../../constants/ColourConstants';

import buildContextMenu from '../Common/BuildContextMenu';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    }

};

const MyCourseListItem = React.createClass({

    getActions: function(row) {

        const infoLink          = `/dashboard/course/${row.id}`;
        const enrolmentLink     = `/dashboard/course/enrolment/${row.enrolmentId}`;

        return [
            {
                link: enrolmentLink,
                label: 'Details',
                icon: <InfoIcon />
            }
        ];
    },

    render: function() {

        const row = this.props.data;
        const infoLink = `/dashboard/course/${row.id}`;

        const actions = (this.props.actions || this.getActions(row));
        const menuItems = buildContextMenu(actions, this.context.auth);
        const success = (row.enrolmentStatus === 'completed');
        const cancelled = (row.enrolmentStatus === 'cancelled');

        let listItemProps = {
            key: row.id,
            style: style.listItem,
            secondaryTextLines: 2
        };

        listItemProps.primaryText = (<Link to={infoLink} className="primaryText">{row.name}</Link>);

        let description = '';
        let avatarIcon  = <SchoolIcon />;
        let avatarStyle = avatarColours.default;

        const enrolmentMethod = (row.isAssigned ? 'Assigned' : 'Booked');

        let iconGroup = [];
        if (row.visibility === 'private') {
            iconGroup.push(<PrivateIcon className="icon-small"  key="visibility" />);
        }

        if (row.skillId) {
            iconGroup.push(<SkillIcon className="icon-small"  key="skill" />);
        }

        if (row.isAssigned) {
            if (row.isMandatory) {
                iconGroup.push(<SpotIcon className="icon-small" color={statusColours.mandatory} key="mandatory"/>);
            } else {
                iconGroup.push(<SpotIcon className="icon-small" color={statusColours.optional} key="optional"/>);
            }
        }


        switch(row.enrolmentStatus) {

            case 'waiting':
                description  = 'On waiting list';
                break;

            case 'enrolled':
                description  = enrolmentMethod;

                if (!!row.enrolmentDate) {
                    const enrolmentDate = new Date(row.enrolmentDate);
                    if (!!enrolmentDate && !isNaN(enrolmentDate.valueOf())) {
                        description += ` on ${enrolmentDate.toDateString()}`;
                    }
                }

                break;

            case 'completed':
                avatarStyle = avatarColours.moduleCompleted;

                description = 'Completed';
                if (!!row.enrolmentDateCompleted) {
                    const completedDate = new Date(row.enrolmentDateCompleted);
                    if (!!completedDate && !isNaN(completedDate.valueOf())) {
                        description += ` on ${completedDate.toDateString()}`;
                    }
                }
                if (!!row.enrolmentScore) {
                        description += ` - Score:  ${row.enrolmentScore}`;
                }
                iconGroup.push(<DoneIcon className="icon-small"  color={statusColours.primary } key="done" />);


                break;

            case 'cancelled':
                avatarStyle = avatarColours.moduleCanceled;
                description = 'Cancelled';
                break;

            default:
                break;

        }

        switch(row.type) {

            case 'classroom':
                avatarIcon = (<SchoolIcon />);
                break;

            case 'e-learning':
                avatarIcon = (<LaunchIcon />);
                break;

            default:
                break;
        }

        if (row.loading) {
            listItemProps.secondaryText = <div><LinearProgress mode="indeterminate"/></div>;
        } else if (row.secondaryText) {
            listItemProps.secondaryText = <Link to={infoLink} className="secondaryInfo">{row.secondaryText}</Link>;
            listItemProps.secondaryTextLines = (row.secondaryTextLines || 2);
        } else {
            listItemProps.secondaryText = (
                <div className="secondaryInfo">
                    <CourseProgressBar courseId={row.id} success={success} cancelled={cancelled}/>
                    {iconGroup}<em>{description}</em>
                </div>
            );
            listItemProps.secondaryTextLines = 2;
        }

        if (menuItems.length > 0) {
            const topRight = {horizontal: 'right', vertical: 'top'};
            const iconMenuProps = {
                menuStyle: style.menu,
                anchorOrigin: topRight,
                targetOrigin: topRight,
                iconButtonElement: (
                    <IconButton touch={true} >
                            <MoreVertIcon color={statusColours.light} style={style.iconButton} />
                        </IconButton>
                )
            };
            listItemProps.rightIcon = (
                <IconMenu {...iconMenuProps} >
                    {menuItems}
                </IconMenu>
            );

        }

        return (

            <ListItem {...listItemProps}
                leftAvatar={
                    <Link to={infoLink}>
                        <Avatar
                            icon={avatarIcon}
                            style={avatarStyle}
                        />
                    </Link>
                }
            />
        );
    }
});

MyCourseListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default MyCourseListItem;
